import { ChangeEvent, KeyboardEvent, useContext } from "react";
import { ToastContext } from "../../../contexts/ToastContext";

type TextInputChange = ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>;

type TextInputProps = {
  value: string | undefined | null;
  onChange: (value: string) => void;
  id: string;
  disabled?: boolean;
  isNumber?: boolean;
  label?: string;
  textarea?: boolean;
  placeholder?: string;
  required?: boolean;
  secondary?: boolean;
  overrideType?: string;
  onEnterKey?: () => void;
  note?: string;
  copyButton?: boolean;
  customButton?: string;
  customButtonHandler?: () => void;
  customButtonDisabled?: boolean;
  customButtonClasses?: string;
  hero?: boolean;
};

const TextInput = ({
  value,
  onChange,
  id,
  disabled,
  label,
  placeholder,
  textarea,
  required,
  secondary,
  overrideType,
  onEnterKey,
  isNumber,
  note,
  copyButton,
  customButton,
  customButtonHandler,
  customButtonDisabled,
  customButtonClasses,
  hero
}: TextInputProps) => {

  const {requestToast} = useContext(ToastContext);

  const handleButton = () => {

    if (copyButton) {
      navigator.clipboard.writeText(value || '');
      requestToast("Copied link.", 'success');
      return;
    }
    customButtonHandler && customButtonHandler();
  }
  
  const onInputChange = (e: TextInputChange) => {
    if (isNumber) {
      const value = e.target.value.replace(/\D/g,'');
      console.log(value);
      onChange(value);
      return;
    };
    onChange(e.target.value);
  }
  
  const handleEnterKey = (code: KeyboardEvent<HTMLInputElement>['key']) => {
    if (!onEnterKey) return;
    if (code === 'Enter') {
      onEnterKey();
    }
  }
  
  if (textarea) return (
    <div className={`text-input multiline ${secondary ? "secondary" : ''}`} aria-required={required}>
      {label && <label htmlFor={id} className="subtitle-medium">{label}</label>}
      <textarea onKeyDown={(e) => handleEnterKey(e.key)} placeholder={placeholder} id={id} value={value || ""} onChange={onInputChange} />
        {note && <p className="subtitle-small weight-light indent secondary">{note}</p>}
    </div>
  )
  return (
    <div
      className={`text-input ${secondary ? "secondary" : ''}`}
      aria-required={required}
      data-label={!!label}
      data-button={!!(copyButton || customButton)}
      data-hero={hero}
      aria-disabled={disabled}
    >
      {label && <label htmlFor={id} className="subtitle-medium">{label}</label>}
      <input onKeyDown={(e) => handleEnterKey(e.key)} type={overrideType || "text"} placeholder={placeholder} id={id} value={value || ""} onChange={onInputChange} />
      {(copyButton || customButton) && 
        <button aria-disabled={customButtonDisabled ?? !value} onClick={handleButton} className={copyButton ? "highlight" : "primary" + ` ${customButtonClasses || ""}`}>
          {customButton || "Copy"}
        </button>
      }
      {note && <p className="subheading-small weight-light indent secondary">{note}</p>}
    </div>
  )
}
export default TextInput;